/**
 * Validates if a string is a valid URL
 * @param {string} urlString - The string to validate
 * @returns {boolean} - True if valid URL, false otherwise
 */
export const isValidUrl = (urlString) => {
  if (!urlString || typeof urlString !== 'string') {
    return false;
  }

  try {
    const url = new URL(urlString);
    // Check if protocol is http or https
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

/**
 * Filters an array of URLs and returns only valid ones
 * @param {Array} urls - Array of URL strings
 * @returns {Array} - Array of valid URLs
 */
export const filterValidUrls = (urls) => {
  if (!Array.isArray(urls)) {
    return [];
  }
  
  return urls.filter(url => isValidUrl(url));
};
